var filtres = {
	checkbox: document.querySelectorAll('#blockFiltre input[type=checkbox]'),
	json: [],
	///
	/// Mise à jour des valeurs de settingsListeResultats{}
	updateSettingsFiltres() {
		settingsListeResultats.filtres.hasFiltre = document.querySelector('.filtre__container') != null ? true : false;
		settingsListeResultats.filtres.isLoadedCalendar = document.getElementById('calendrier') != null ? true : false;
	},
	updateSettingsResultats(url) {
		// on met à jour le nombre de résultats
		if (document.getElementById('nbreCircuitsTotal') != null) {
			settingsListeResultats.resultats.nbreVoyages = parseInt(document.getElementById('nbreCircuitsTotal').value);
		} else {
			settingsListeResultats.resultats.nbreVoyages = 0
		}
		settingsListeResultats.resultats.nbreVoyagesAffiches = document.querySelectorAll('#nos-voyages .circuit').length;

		settingsListeResultats.resultats.showPagination = settingsListeResultats.resultats.nbreVoyages > 30 ? true : false;

		document.documentElement.classList.remove('has--filtre-open');
	},


	///
	/// Mise à jour de filtres.json (PUT, SET, DELETE)
	pushFiltersCheckedInArray(a) {
		// On push tous les checked dans le tableau
		[].forEach.call(a, function (el) {
			if (el.checked) {
				let name = el.name;
				let id = el.id;
				filtres.setFilterInArray(name, id);
			}
		});
		// Cas avec une date
		let url = window.location.search.slice(2); // on récupère les paramètres
		let params = new URLSearchParams(url);
		let newDate = params.get('_date');
		if (newDate != null) {
			// On pousse les données dans le json
			let newData = {
				'filtre': 'date',
				'value': newDate
			}
			filtres.json.push(newData);
		}
	},
	getFlexibilite() {
		// Variables
		let valeur = document.getElementById('flexibiliteLR').value;
		let arr = filtres.json;
		let newflex = {
			'filtre': 'flexibilite',
			'value': valeur
		}

		// On supprime la flexibilité précédente
		for (var i = arr.length - 1; i >= 0; i--) {
			if (arr[i].filtre === 'flexibilite') {
				arr.splice(i, 1);
			}
		}

		filtres.json.push(newflex);
	},
	setFilterInArray(name, id) {
		let value = id.split('-');
		let newData = {
			'filtre': name,
			'value': value[1]
		}

		if (name === 'typecircuit') {
			var nbtypes = ['1', '2', '3', '7', '10'];

			for (var i = 4; i >= 0; i--) {
				filtres.deleteFilterInArray('typecircuit', 'typecircuit-' + nbtypes[i]);
			}
		}
		filtres.json.push(newData);
	},
	deleteFilterInArray(name, id) {
		let arr = filtres.json;
		let newJson = [];
		let value = id.split('-');
		let deletedData = {
			'filtre': name,
			'value': value[1]
		}

		function deleteObj(obj) {
			if (obj.filtre === name) {
				if (obj.value === value[1]) {
					return false;
				} else {
					return true;
				}
			} else {
				return true;
			}
		}

		newJson = arr.filter(deleteObj);
		filtres.json = newJson;
	}
}



class filtring extends ListeResultat {
	initialize() {

		let self = this;

		///	--------------	1 	--------------
		/// Au load, on récupère tous les filtres cochés
		/// et on les push dans l'array d'objects filtres.json
		filtres.pushFiltersCheckedInArray(filtres.checkbox);


		///	--------------	2 	--------------
		/// On écoute tous les événements 'change' de #blockFiltre
		/// et on appelle la fonction handlerFiltre
		document.getElementById('blockFiltre').addEventListener('change', function (e) {
			self.handlerFiltre(e);
		});

		///	--------------	X 	--------------
		/// Au cas où l'utilisateur fait un back navigateur
		/// on met à jour filtres.json et on upload les résultats
		window.addEventListener('popstate', function (event) {
			if (event.explicitOriginalTarget.tagName !== 'IMG' && event.explicitOriginalTarget.tagName !== 'A') {
				self.goBackNavigation();
			}
		});
	}

	/// La mise à jour de filtres.json en cas de back navigateur
	goBackNavigation() {
		filtres.json.pop();
		this.reloadResultat();
	}

	///	--------------	3 	--------------
	/// L'event change est provoqué par trois actions :
	///	a. check/uncheck un filtre
	/// b. choix d'une flexibilité
	/// c. tri des résultats
	/// On gère le tri || on met à jour filtres.json puis on appelle
	/// Selon le cas, on lance les actions correspondantes
	/// ❌❌ Attention ❌❌
	/// dans le cas d'une date sélectionnée,
	/// on appelle le filtring est géré à partir de la méthode onSelect de ListeResultat.calendrier (dans app.js)
	handlerFiltre(e) {
		let self = this;

		document.body.classList.add('loading');

		// On a sélectionné une flexibilité
		if (e.target.id == 'flexibiliteLR') {
			filtres.getFlexibilite();
		}
		// On a trié les résultats
		else if (e.target.className.indexOf('js-tri') >= 0) {
			let tri = {
				typeTri: e.target.id
			};
			window.sessionStorage.setItem('tri', tri.typeTri);
			document.querySelector('.tri .box--filtre').hidden = true;

			/// On recharge le block des résultats
			self._ajaxCall(settingsListeResultats.lr.urlTrierListeResultats, tri, '#nos-voyages', filtres.updateSettingsResultats);

			///
			/// On relance les functions liées aux résultats
			///
			const getMoreResultats = new moreResultat();

			/// Les circuits
			//sliders.circuits();
			//sliders.encartContextualisation();

			/// Pagination
			getMoreResultats.initialize();

			/// Les favoris
			selection.init(settingsApp.favoris);

			// On se positionne en haut de liste
			document.getElementById('nos-voyages').scrollIntoView({
				block: "start",
				inline: "nearest"
			});


			/// Uniquement pour terdav.be
			settingsApp.app === 'TDV' && settingsApp.belge && commons.convertButtonToLink('data-voyage');

			document.body.classList.remove('loading');
		}
		// On a coché ou décoché un filtre
		else {
			self.eventFilterChanged(e);
		}

		// Dans le cas où l'on a filtré (et non trié)
		// on reload les résultats
		if (e.target.id != 'trier' && e.target.className.indexOf('js-tri') < 0) {
			try {
				self.reloadResultat();
			} catch (e) {
				console.error(e);
				location.reload()
			}
		}
	}

	///
	/// Appel des fonctions Set/delete de filtres.json
	eventFilterChanged(event) {
		event.target.checked ? filtres.setFilterInArray(event.target.name, event.target.id) : filtres.deleteFilterInArray(event.target.name, event.target.id);
	}

	///	--------------	4 	--------------
	/// On poste filtres.json via la function ajaxcall() et on récupère la data
	/// On réinit les functions js utilisées
	reloadResultat() {


		let idBlockFiltres = 'blockFiltre',
			idNosVoyages = 'nos-voyages';

		this._keepParametersTracking();

		// On reload les résultats
		this._ajaxCall(settingsListeResultats.lr.urlFiltreListeResultats, JSON.stringify(filtres.json), `#${idNosVoyages}`, filtres.updateSettingsResultats);

		// On reload les filtres
		this._ajaxCall(settingsListeResultats.lr.urlCalculFiltreListeResultats, JSON.stringify(filtres.json), `#${idBlockFiltres}`, filtres.updateSettingsFiltres);

		// On relance les functions liées aux filtres et aux résultats
		selection.init(settingsApp.favoris);
		const calendar = new calendrier();
		const utilities = new utilitiesListeResultat();
		lr.filtresResultats(true, this, calendar);

		// On se positionne en haut de liste
		document.getElementById(idNosVoyages).scrollIntoView({
			block: "start",
			inline: "nearest"
		});


		/// Uniquement pour terdav.be
		settingsApp.app === 'TDV' && settingsApp.belge && commons.convertButtonToLink('data-voyage');

		// On retire la class du loader
		document.body.classList.remove('loading');
	}

	///
	/// La requête ajax
	_ajaxCall(url, data, container, callback) {

		if (url != settingsListeResultats.lr.urlTrierListeResultats) {
			data = {
				filtresCoches: data
			};
		}
		$.ajax({
			url: url,
			async: false,
			data: data,
			type: "POST",
			dataType: "json",
			success: function (data) {
				if (container != '') {
					$(container).html(data);
				}
			},
			error: function (jqXHR, textStatus, errorThrown) {
				document.location.reload(true);
				console.error(jqXHR, textStatus, errorThrown)
			},
			complete: function (url) {
				callback(url);
				document.body.classList.remove('has-overlay');
				document.querySelector('.body-blackout').classList.remove('is-blacked-out');
				window.sessionStorage.setItem('currentPage', window.location.href);
			}
		});
	}

	/// On doit conserver les paramètres de traking après avoir filtré
	_keepParametersTracking() {

		var urlParams;
		(window.onpopstate = function () {
			var match,
				pl = /\+/g, // Regex for replacing addition symbol with a space
				search = /([^&=]+)=?([^&]*)/g,
				decode = function (s) {
					return decodeURIComponent(s.replace(pl, " "));
				},
				query = window.location.search.substring(1);

			urlParams = {};

			while (match = search.exec(query))
				urlParams[decode(match[1])] = decode(match[2]);
		})();

		let filtreDansURL = '',
			urlMAJ = window.location.protocol + "//" + window.location.host + window.location.pathname,
			parametresTracking = '';

		//On récupère les paramètres de tracking qui devront toujours être présent dans l'URL

		if ("codori" in urlParams)
			parametresTracking += "&codori=" + urlParams["codori"];

		if ("xtor" in urlParams)
			parametresTracking += "&xtor=" + urlParams["xtor"];

		if ("kard" in urlParams)
			parametresTracking += "&kard=" + urlParams["kard"];

		if ("cible" in urlParams)
			parametresTracking += "&cible=" + urlParams["gclid"];

		if ("cible" in urlParams)
			parametresTracking += "&cible=" + urlParams["cible"];

		if ("flush" in urlParams)
			parametresTracking += "&flush=" + urlParams["flush"];

		if ("utm_medium" in urlParams)
			parametresTracking += "&utm_medium=" + urlParams["utm_medium"];

		if ("utm_source" in urlParams)
			parametresTracking += "&utm_source=" + urlParams["utm_source"];

		if ("utm_campaign" in urlParams)
			parametresTracking += "&utm_campaign=" + urlParams["utm_campaign"];

		if (parametresTracking.length > 0)
			parametresTracking = parametresTracking.substring(1);

		for (var i = 0; i <= filtres.json.length - 1; i++) {
			filtreDansURL += "&_" + filtres.json[i].filtre + "=" + filtres.json[i].value;
		}

		if (filtreDansURL.length > 0) {
			//URL SEO
			if (window.location.pathname != "/recherche/listeresultats")
				urlMAJ = urlMAJ + "?" + parametresTracking + filtreDansURL;
			//URL Technique
			else {
				var urlSansFiltre = window.location.search.substring(window.location.search.indexOf("?"));

				//On est dans le cas d'une URL technique avec filtre
				if (urlSansFiltre.indexOf("&_") > -1)
					urlSansFiltre = urlSansFiltre.substring(0, urlSansFiltre.indexOf("&_"));

				urlMAJ = urlMAJ + urlSansFiltre + filtreDansURL;
			}
		} else {
			//Si je déselectionne tous les filtres mais que je suis sur une URL technique, alors garder les critères moteur
			if (window.location.pathname == "/recherche/listeresultats") {
				var urlSansFiltre = window.location.search.substring(window.location.search.indexOf("?"));

				if (urlSansFiltre.indexOf("&_") > -1)
					urlSansFiltre = urlSansFiltre.substring(0, urlSansFiltre.indexOf("&_"));

				urlMAJ = urlMAJ + urlSansFiltre;
			}
		}
		window.history.pushState({
			path: urlMAJ
		}, '', urlMAJ);
	}
}